var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.1708.941603c.3746.118097.6294.465537.6294.858367v4.5h3.6c.3356 0 .6433.18671.7983.48437s.1315.65682-.061.93174l-6.29999 9.00002c-.22527.3218-.63324.4603-1.00789.3422s-.62942-.4655-.62942-.8583v-4.5h-3.6c-.33559 0-.6433-.1867-.79828-.4844s-.13148-.6568.06097-.9317l6.3-9.00005c.22527-.321812.63323-.460345 1.00791-.342247z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.4ede01f94f870ce3075225efbec00f73.svg";
export { ForwardRef as ReactComponent };